import './TermsAgreementInfo.scss';
import React, { useState, useEffect } from 'react';
import DialogComponent from './DialogComponent'; 


const TermsAgreementInfo = ({}) => {

  const [openTermsDialog, setOpenTermsDialog] = useState(false);
  const [openPrivacyDialog, setOpenPrivacyDialog] = useState(false);
  const [termsContent, setTermsContent] = useState('');
  const [privacyContent, setPrivacyContent] = useState('');
  
  useEffect(() => {
    // 이용약관 내용 로드
    fetch('/terms-of-service.txt')//public폴더에 있음
      .then(response => response.text())
      .then(text => setTermsContent(text))
      .catch(error => console.error('Error loading the terms of service:', error));

    // 개인정보 수집 약관 내용 로드
    fetch('/privacy-policy.txt')
      .then(response => response.text())
      .then(text => setPrivacyContent(text))
      .catch(error => console.error('Error loading the privacy policy:', error));
  }, []);

  const onOpenTermsDialog = () => {
    setOpenTermsDialog(true);
  };

  const onOpenPrivacyDialog = () => {
    setOpenPrivacyDialog(true);
  };

  const onCloseTermsDialog = () => {
    setOpenTermsDialog(false);
  };

  const onClosePrivacyDialog = () => {
    setOpenPrivacyDialog(false);
  };

//============================================================
  return (
    <div className='TermsAgreementInfo'>
      <section className='section-info'>

      <article class="article-info">
          <p class="">안내사항</p>
          <p class="">회원정보는 <a onClick={onOpenPrivacyDialog}>개인정보 처리방침</a> 및 <a onClick={onOpenTermsDialog}>회원약관</a>에 의해 관리됩니다.</p>
          <p class="">회원정보 보호를 위해 아이디의 일부분은 비공개 처리됩니다.</p>
          <p class="">위의 방법으로 회원 아이디 찾기가 불가능한 경우, 고객상담전화(033-735-8805)로 문의 바랍니다.</p>
      </article>

      {/* 이용약관 대화상자 */}
      <DialogComponent open={openTermsDialog} onClose={onCloseTermsDialog} title="이용약관"
      >
        {termsContent}
      </DialogComponent>
      
      {/* 개인정보 수집 약관 대화상자 */}
      <DialogComponent open={openPrivacyDialog} onClose={onClosePrivacyDialog} title="개인정보 수집 약관" >
        {privacyContent}
      </DialogComponent>

    </section>
    </div>
  );
};

export default TermsAgreementInfo;
